export enum CategoryTypeEnum {
    'e-learning'=1,
    'Présentiel'=2,
}
